import PropTypes from "prop-types";
import React from "react";

const CreateExpenseButton = ({ onClick }) => {
  return (
    <a
      href="#"
      onClick={onClick}
      className="fixed bottom-28 right-0 bg-blue-700 dark:bg-blue-600 dark:focus:ring-blue-800 dark:hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium hover:bg-blue-800 inline-flex items-center mx-4 px-2.5 py-2.5 rounded-full text-center text-sm text-white"
    >
      <svg
        className="w-10 h-10 text-white dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 12h14m-7 7V5"
        />
      </svg>
    </a>
  );
};

CreateExpenseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CreateExpenseButton;
